import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { IconButton } from '@calendly/ui/components/icon-button';
import { AlertWarningTriangleIcon, DeleteIcon } from '@calendly/ui/components/icons';
import { errorColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
import { PanelContentContainer } from '../../styles';
import { useHostsListData, useRemoveUserPool, useUserPoolsData } from '../hooks';
import { HostsList } from './round_robin';
const contextualBannerButtonContainerCss = "c167jnjl";
const ContextualBannerButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contextualBannerButtonContainerCss, props.className)} />;
});
const ErrorBanner = ({
  errorMessage,
  isSubmitting,
  onRemoveUserPool,
  showRemoveButton
}) => <ContextualBanner variant="danger" icon={AlertWarningTriangleIcon}>
    <Layout justify="space-between">
      {errorMessage}
      {showRemoveButton && <ContextualBannerButtonContainer>
          <IconButton size="small" disabled={isSubmitting} onClick={onRemoveUserPool} title={I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.remove_user_pool')}>
            <DeleteIcon color={errorColor} />
          </IconButton>
        </ContextualBannerButtonContainer>}
    </Layout>
  </ContextualBanner>;
export const CoHostsAndUserPools = ({
  eventType,
  isLocked
}) => {
  const removeUserPool = useRemoveUserPool(eventType);
  const {
    isSubmitting
  } = useFormContext();
  const {
    collectiveUserPool,
    collectiveUserPoolUid,
    hasCollectiveUserPools,
    hasRoundRobinUserPools,
    isLastUserPool
  } = useUserPoolsData();
  const {
    hasError,
    errorMessage
  } = useHostsListData(collectiveUserPool, eventType.isTeam);
  const showError = hasError && hasCollectiveUserPools && !hasRoundRobinUserPools;
  return <PanelContentContainer section data-component="hosts-list">
      {showError && <ErrorBanner errorMessage={errorMessage} isSubmitting={isSubmitting} onRemoveUserPool={() => removeUserPool(collectiveUserPoolUid)} showRemoveButton={!isLastUserPool && !isLocked} />}
      <HostsList eventType={eventType} userPool={collectiveUserPool} isLocked={isLocked} showHostsList={hasCollectiveUserPools} showUserPoolsList={hasRoundRobinUserPools} skipPagination={hasRoundRobinUserPools} />
    </PanelContentContainer>;
};

require("./co_hosts_and_user_pools.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./co_hosts_and_user_pools.js");